import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IUserSchemaPartial } from '../../type/user';

export interface IGetCurrentLoggedInUserMutationFields {}


export interface IGetCurrentLoggedInUserMutationResponseFields {
  currentLoggedInUser: IUserSchemaPartial | null;
  isSuperAdmin: boolean;
}


export function getCurrentLoggedInUserMutation(fragment: string): DocumentNode {
  return gql`
        mutation getCurrentLoggedInUser
         {
        getCurrentLoggedInUser
         {
        ...fragment
        }
        }
        fragment fragment on GetCurrentLoggedInUserMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useGetCurrentLoggedInUserMutation<TData extends Partial<IGetCurrentLoggedInUserMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ getCurrentLoggedInUser: TData },
        IGetCurrentLoggedInUserMutationFields>,
) {
  return useMutation<{ getCurrentLoggedInUser: TData },
      IGetCurrentLoggedInUserMutationFields>(
        getCurrentLoggedInUserMutation(fragment), options,
      );
}
